import './App.css';
import Navigation from './pages/Navigation';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DataScienceMasterClass from './pages/DataScienceMasterClass';
import DataAnalysisPython from './pages/DataAnalysisPython';
import MasteringGenAI from './pages/MasteringGenAI'
import OurTeam from './pages/OurTeam.js'
import MLOPS from './pages/MLOPS.js';
import AdvancedLLM from './pages/AdvancedLLM.js';
import AllCourses from './pages/AllCourses.js'
import TrainingAndWorkshop from './pages/TrainingAndWorkshop.js';
import ScheduleCall from './pages/ScheduleCall.js'
import MasteringAndBuilding from './pages/MasteringAndBuiding.js';
import ProductManagementAI from './pages/ProductManagementAI.js';
import CourseRegistrationform from './pages/CourseRegistrationForm.js';

function App() {
  return (
    <>
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Navigation/>}/>
      <Route path='/datasciencemasterclass' element={<DataScienceMasterClass/>}/>
      <Route path='/dataAnalysisWithPython' element={<DataAnalysisPython/>}/>
      <Route path='/masteringGenAI' element={<MasteringGenAI/>}/>
      <Route path='/ourteam' element={<OurTeam/>}/>
      <Route path='/mlops' element={<MLOPS/>}/>
      <Route path='/advancedllm' element={<AdvancedLLM/>}/>
      <Route path='/allcourses' element={<AllCourses/>}/>
      <Route path='/trainingandworkshop' element={<TrainingAndWorkshop/>}/>
      <Route path='/schedulecall' element={<ScheduleCall/>}/>
      <Route path='/masteringandbuildingproduct' element={<MasteringAndBuilding/>}/>
      <Route path='productmanagementinai' element={<ProductManagementAI/>}/>
      <Route path='/courseregistration' element={<CourseRegistrationform/>}/>
    </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
